import { render, staticRenderFns } from "./_base-navbar.vue?vue&type=template&id=0ce97014&scoped=true&"
import script from "./_base-navbar.vue?vue&type=script&lang=js&"
export * from "./_base-navbar.vue?vue&type=script&lang=js&"
import style0 from "./_base-navbar.vue?vue&type=style&index=0&id=0ce97014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce97014",
  null
  
)

export default component.exports